import React from "react";
import clsx from "clsx";

import useStyles from "./styles";

interface IProps {
  children: React.ReactNode;
  className?: string;
}

const FieldErrorMessage = (props: IProps) => {
  const { className, children } = props;
  const classes = useStyles();

  if (!children) return;

  return (
    <div className={clsx(classes.fieldErrorMessage, className)}>{children}</div>
  );
};

export default React.memo(FieldErrorMessage);
